import * as React from 'react';

import PropTypes from 'prop-types';
import { compose } from 'recompose';
import type { LegacyContextType } from 'types/legacy-context-types';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import {
  addCourseScope,
  removeCourseScope,
  setSelectedCourseScope,
  updateCourseScope,
} from 'bundles/widget-simulator/actions/WidgetSimulatorActions';
import OptionsFormGroup from 'bundles/widget-simulator/components/tools/OptionsFormGroup';
import type WidgetSimulatorStoreClass from 'bundles/widget-simulator/stores/WidgetSimulatorStore';
import type { Option } from 'bundles/widget-simulator/types';

import _t from 'i18n!nls/widget-simulator';

type PropsFromCaller = {};

type PropsFromStores = {
  options: Array<Option>;
  selectedOption: Option | undefined;
};

export type PropsToComponent = PropsFromCaller & PropsFromStores;

class CourseScopeEditor extends React.Component<PropsToComponent> {
  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof CourseScopeEditor.contextTypes>;

  handleAddButtonClick = () => {
    const { executeAction } = this.context;

    // TODO: Create a modal for this.
    // eslint-disable-next-line no-alert
    const label = prompt(_t('Enter a name for this scope:'));

    if (label) {
      executeAction(addCourseScope, { label });
    }
  };

  handleEditButtonClick = () => {
    const { executeAction } = this.context;
    const { selectedOption } = this.props;

    if (!selectedOption) {
      return;
    }

    // TODO: Create a modal for this.
    // eslint-disable-next-line no-alert
    const label = prompt(_t('Enter a new name for this scope:'));

    if (label) {
      executeAction(updateCourseScope, {
        id: selectedOption.id,
        newProps: { label },
      });
    }
  };

  handleRemoveButtonClick = () => {
    const { executeAction } = this.context;
    const { options, selectedOption } = this.props;

    if (!selectedOption) {
      return;
    }

    const selectedIndex = options.findIndex((option) => option.id === selectedOption.id);

    // TODO: Create a modal for this.
    // eslint-disable-next-line no-alert,
    if (confirm(_t('Are you sure you want to delete this scope? This cannot be undone.'))) {
      executeAction(removeCourseScope, { index: selectedIndex });
    }
  };

  handleSelectChange = (event: $TSFixMe) => {
    const { executeAction } = this.context;
    const { options } = this.props;
    const selectedId = event.target.value;
    const selectedIndex = options.findIndex((option) => option.id === selectedId);

    executeAction(setSelectedCourseScope, { selectedIndex });
  };

  renderOptions() {
    const { options } = this.props;

    if (!options) {
      return <option>{_t('Loading...')}</option>;
    } else if (options.length === 0) {
      return <option>{_t('Add a Course Scope...')}</option>;
    } else {
      return options.map((option) => (
        <option key={option.id} value={option.id}>
          {option.label}
        </option>
      ));
    }
  }

  render() {
    const { options, selectedOption } = this.props;

    return (
      <OptionsFormGroup
        label={_t('Course')}
        options={options}
        selectedOption={selectedOption}
        onAddButtonClick={this.handleAddButtonClick}
        onEditButtonClick={this.handleEditButtonClick}
        onRemoveButtonClick={this.handleRemoveButtonClick}
      >
        <select className="control" value={selectedOption && selectedOption.id} onChange={this.handleSelectChange}>
          {this.renderOptions()}
        </select>
      </OptionsFormGroup>
    );
  }
}

type Stores = {
  WidgetSimulatorStore: typeof WidgetSimulatorStoreClass;
};

export default compose<PropsToComponent, PropsFromCaller>(
  connectToStores<PropsFromStores, {}, Stores>(['WidgetSimulatorStore'], ({ WidgetSimulatorStore }) => ({
    options: WidgetSimulatorStore.getCourseScopes(),
    selectedOption: WidgetSimulatorStore.getSelectedCourseScope(),
  }))
)(CourseScopeEditor);
